import type { RevenueBreakdown } from '@weft/types';

export function buildEmptyRevenueBreakdown(): RevenueBreakdown {
  return {
    total: 0,
    subtotal: 0,
    discount: 0,
    overage: 0,
    creditsUsed: 0,
    tax: 0,
  };
}